import { Empty } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import { getCaseList } from '../../../api/aopsCase.api'
import '../../../pages/aopsCase/caseTrackBoard.scss'
import { userState } from '../../../store/user'
import SectionHeader from '../SectionHeader'
import CaseTrackBoardCard from './CaseTrackBoardCard'
import CaseTrackBoardModal from './CaseTrackBoardModal'
// import "../../../pages/standaloneSchedule"
const CaseTrackBoard = () => {
  const navigate = useNavigate()
  const [openCaseModal, setOpenCaseModal] = useState(false)
  const [caseList, setCaseList] = useState([])
  const [caseDetail, setCaseDetail] = useState(null)
  const [user] = useRecoilState(userState)
  useEffect(() => {
    fetchCaseList()
  }, [])
  const openErrorModal = (error) => {
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: error.response.data.detail[1].description,
    })
  }
  const fetchCaseList = async () => {
    try {
      const res = await getCaseList(user?.id)
      setCaseList(res)
    } catch (error) {
      console.log(error)
      openErrorModal(error)
      setCaseList([])
      return
    }
  }

  // const fetchCaseDetail = async (caseWorkId) => {
  //   try {
  //     const res = await getCaseDetail(caseWorkId)
  //     console.log(res, 'res')
  //     setOpenCaseModal(true)
  //     setCaseDetail(res)
  //   } catch (error) {
  //     console.log(error)
  //     openErrorModal(error)
  //   }
  // }

  const goToCaseDetail = (caseWorkId, step) => {
    // step이 있으면 쿼리 스트링 추가, 없으면 그냥 이동
    const url = step
      ? `/case/${caseWorkId}?step=${step}`
      : `/case/${caseWorkId}`
    navigate(url)
  }

  return (
    <>
      <section className="case-track-board">
        <SectionHeader
          title="케이스 추적 대시보드"
          subtitle="케이스를 직접 만들어 대시보드로 확인할 수 있어요"
          buttonText="케이스 생성"
          onButtonClick={() => setOpenCaseModal(true)}
        />

        {/* 케이스 대시보드 */}
        <section className="case-track-card-container">
          {caseList.map((item) => (
            <CaseTrackBoardCard
              key={item.caseWorkId}
              caseTitle={item.caseTitle}
              emojiText={item.emojiText}
              process={item.caseWorkProcessStates || []}
              onClickDetail={(step) =>
                goToCaseDetail(item.caseWorkId, item.step)
              }
              caseWorkId={item.caseWorkId}
            />
          ))}
        </section>
        {caseList.length === 0 && (
          <div className="empty-list">
            <Empty description="등록된 케이스가 없습니다" />
          </div>
        )}
      </section>
      <CaseTrackBoardModal
        open={openCaseModal}
        onClose={() => setOpenCaseModal(false)}
        fetchCaseList={fetchCaseList}
        caseDetail={caseDetail}
      />
    </>
  )
}

export default CaseTrackBoard
